import React, {useState, useEffect} from 'react';
import { Button, Select_simple, Input } from './ui';
import {optionsAreaResponsable, optionsEtapaExpediente} from "../datos/options";

const FiltrosTabla = ({
	filters,
	setFilters,
	data,
	handleFilterChange,
	limpiarFiltros
}) => {
	console.log("DATAx en FiltrosTabla (2)--->", data)

	const [obrasUnicas, setObrasUnicas] = useState([]);
	//console.log("OBRA UNICAS --->", obrasUnicas)
	const [expedientes, setExpedientes] = useState([]);
	//console.log("EXPEDIENTES --->", expedientes)
	const [objetosUnicos, setObjetosUnicos] = useState([]);
	
	{/* estado para manejar porcerntaje de estado_expdiente */}
	

	useEffect(() => {
		//const nombresObras = [...new Set(data.map(item => item.nombre_obra))].filter(Boolean);
		const nombresUnicos = new Set(data.map(item => item.nombre_obra));

		const arrayObras = Array.from(nombresUnicos).map(nombre => ({
			value: nombre,
			label: nombre
		  }));
		setObrasUnicas(arrayObras);		
	}, [data]);

	//useEffect para objetos unicos
	useEffect(() => {
		const estadosFiltrados = data
            .map(item => item.objeto)
            .filter(objeto => objeto && objeto !== ''); // Filtra los vacíos y nulos

		const nombresUnicosObjetos = new Set(estadosFiltrados);

		const arrayObjetos = Array.from(nombresUnicosObjetos).map(nombre => ({
			value: nombre,
			label: nombre
		  }));
		setObjetosUnicos(arrayObjetos);		
	}, [data]);

	useEffect(() => {
		const arrayExpedientes = data.reduce((acumulador, objetoActual) => {
		  // Creamos el nuevo objeto en el formato deseado
		  const nuevoExpediente = {
			value: objetoActual.exp,
			label: objetoActual.exp,
			ref_obra: objetoActual.nombre_obra
		  };
	
		  // Agregamos el nuevo objeto al array acumulador
		  acumulador.push(nuevoExpediente);
	
		  // Devolvemos el array acumulador para la siguiente iteración
		  return acumulador;
		}, []); // El valor inicial del acumulador es un array vacío []
	
		setExpedientes(arrayExpedientes);
	  }, [data]);

    
	return (
		<div className="mb-6 p-4 border border-gray-200 rounded-lg bg-white shadow-sm dark:bg-gray-800 dark:border-gray-700">
			<div className="flex justify-between items-center mb-4">
				<h3 className="text-lg font-medium text-gray-900 dark:text-white">Filtros</h3>
				<Button
					onClick={limpiarFiltros}
					className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 text-gray-700 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-white rounded-md transition-colors"
				>
					Limpiar filtros
				</Button>				
			</div>

			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
				<div>
					<label htmlFor="area_responsable" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Área Responsable
                    </label>
					<Select_simple
						name="area_responsable"
						value={filters.area_responsable}
						onChange={handleFilterChange}//{(e) => setFiltroNombreObra(e.target.value)}
						options={optionsAreaResponsable}
						placeholder="Todos los trámites por áreas responsables"
					/>
				</div>
				<div>
					<label htmlFor="nombre_obra" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Nombre de Obra
                    </label>
					<Select_simple
						name="nombre_obra"
						value={filters.nombre_obra}
						onChange={handleFilterChange}//{(e) => setFiltroNombreObra(e.target.value)}
						options={obrasUnicas}
						placeholder="Todos los trámites por nombre de obra"
						//className="block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
					/>					
				</div>	
				<div>
					<label htmlFor="expediente" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Expediente
                    </label>
					<select
						name="expediente"
						value={filters.expediente}
						onChange={handleFilterChange}//{(e) => setFiltroExpediente(e.target.value)}
						className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 h-10"
					>
					<option value="">Todos los trámites por expedientes</option>
					{expedientes.map((exp, index) => (
						<option key={index} value={exp.value}>{exp.label}-{exp.ref_obra}</option>
					))}
				</select>
				</div>
				
			</div>
			<div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
				<div>
					<label htmlFor="objeto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Objeto
                    </label>
					<Select_simple
						name="objeto"
						value={filters.objeto}
						onChange={handleFilterChange}//{(e) => setFiltroExpediente(e.target.value)}
						options={objetosUnicos}
						placeholder="Todos los trámites por objeto"
					/>
				</div>
				{/* Filtrar por Etapa Expediente (Salida convenio 25%, Firma Convenio 50%, Salida Resolución 75%, Firma Resolución 100%) */}
				<div>
					<label htmlFor="etapa_expediente" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Etapa Expediente
                    </label>
					<Select_simple
						name="etapa_expediente"
						value={filters.etapa_expediente}
						onChange={handleFilterChange}//{(e) => setFiltroExpediente(e.target.value)}
						options={optionsEtapaExpediente}
						placeholder="Todos los trámites por etapa de expediente"
					/>
				</div>
				{/* Búsqueda */}
				<div className="w-full">
					<label htmlFor="search" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Buscar
                    </label>
					<div className="relative">
						<Input
							type="text"
							name="search"
							value={filters.search}
							onChange={handleFilterChange}
							placeholder="Buscar por Id, Nombre de obra o Expediente..."
							className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
						/>
						<div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
							<svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
								<path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
							</svg>
						</div>
					</div>
				</div>
				<div>{/* dejar vacio */}</div>
			</div>
		</div>
	);
};

export default FiltrosTabla;